import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { startLifetimeAvailability } from './lifetimeAvailability.js';
import { startContentEnhancements } from './contentEnhancements.js';
import './index.css';

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);

startLifetimeAvailability();
startContentEnhancements();